<template>
    <div v-if="baseData && baseData.activityId" class="bargain-ctn">
        <div class="bargain" @touchstart.prevent="launchBargain(baseData.showStatus)">
            <img src="@/assets/bargin.png"/>
            <span class="bargain-slogan" v-if="baseData.bargainId && baseData.priceCount && baseData.showStatus != 3"><em>{{baseData.peopleCount}}</em>位好友帮砍，累计<em>￥{{baseData.priceCount}}</em></span>

            <span class="bargain-slogan" v-else>邀好友来砍价，最高可砍<em><i>￥</i>{{baseData.bargainMax}}</em></span>
            <div :class="bargainLoading ? 'bargaining' : '' ">
                <span v-if="bargainLoading">加载中</span>
                <span v-else-if="baseData.showStatus && (baseData.showStatus==1 || baseData.showStatus==2)">邀请好友</span>
                <span v-else class="launch-bargain">发起砍价</span>
                <img src="https://m1.tuniucdn.com/fb2/t1/G4/M00/01/4C/Cii_J1y-8QGIcXMwAAAAkJqb5XcAAFchgP__uwAAAEU982_w640_h0_c0_t0.png">
                <!-- <i class="arrow"></i> -->
            </div>
        </div>
        <div v-if="isShowBargainWrap">
            <vui-popup v-model="isShowBargain" class="bargain-pop">
                <canvas id="J_bargain-canvas" :width="264*ratio" :height="394*ratio" class="canvas" style="display:none"></canvas>
                <img id="J_image" crossorigin="anonymous">
                <div class="bargain-pop-notice">
                    <span v-if="isWeixin">微信内长按识别小程序码</span>
                    <span v-else>长按保存图片后在微信内分享</span>
                </div>
            </vui-popup>
        </div>
    </div>
</template>

<script>
    import '@tuniu/dpl-vui/lib/vui-css/base.css';
    import '@tuniu/dpl-vui/lib/vui-css/popup.css';
    import Vue from 'vue';
    import { versionCmp } from '@/business/global';
    import { createBargainOrderP, getQrCodeP } from 'create-api';
    const { resizeImage } = require('@tuniu/light-helper');
    const LOGIN_URL = '/u/login';
    const CREATE_BARGAIN_ERROR_MESSAGE = '创建砍价活动失败，请稍后重试';
    const CREATE_QR_CODE_ERROR_MESSAGE = '生成砍价小程序码失败，请稍后重试';
 
    export default {
        name: 'bargain',
        data() {
            return {
                isShowBargain: false,
                loadImageCount: 0,
                bargainLoading: false,
                isShowBargainWrap: false,
                isWeixin: typeof navigator !== 'undefined' && /MicroMessenger/i.test(navigator.userAgent),
                _bargainId: ""
            }
        },
        components: {
        },
        props: {
            baseData: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            productId: {
                type: Number,
                default: function () {
                    return 0
                }
            },
            destinationName: {
                type: String,
                default: ''
            },
            image: {
                type: Object,
                default: function() {
                    return {
                        size: 2,
                        productImageList: []
                    }
                }
            },
            lowestPrice: {
                type: Number,
                default: function () {
                    return 0
                }
            },
            productName: {
                type: String,
                default: ''
            },
            classBrandParentName: {
                type: String,
                default: ''
            },
            remarkSatisfaction: {
                type: Number,
                default: function () {
                    return 100
                }
            },
            travelCount: {
                type: Number,
                default: function () {
                    return 0
                }
            },
        },
        mounted() {
            this.isShowBargainWrap = true;
        },
        computed: {
            headPic () {
                if (this.image && this.image.productImageList && this.image.productImageList.length) {
                    return resizeImage(this.image.productImageList[0].imageUrl, 640, 480, 1);
                } else {
                    return undefined;
                }
            },
            slogan () {
                return `我正在途牛旅游发起砍价优惠，最高可砍${this.baseData && this.baseData.bargainMax}元，够朋友，就来帮我砍吧`;
            },
            ratio () {
                return typeof window !== 'undefined' ? window.devicePixelRatio : 2;
            },
            isApp () {
                return this.$store.getters['detail/isApp'];
            },
            isTuniuWeApp () {
                return window.G && window.G.isWeApp;
            }
        },
        methods: {
            launchBargain (status) {
                if (this.bargainLoading) {
                    return;
                };
                let url;
                // 邀请好友
                if(status == 1 || status == 2){
                    url = "/bargain/pages/detail?scene=" + this.baseData.bargainId;
                };
                // 发起砍价
                if(status == 0){
                    url = '/bargain/pages/detail?product=' + this.productId + '&activeId=' + this.baseData.activityId
                };
                (this.baseData && this.baseData.bargainId ? Promise.resolve() : this.createBargainOrder()).then(() => {
                    if (this.isApp) {
                        this.callBargainJSBridge();
                    }else if(this.isTuniuWeApp){
                        let UA = navigator.userAgent;
                        if (/MicroMessenger\//i.test(UA)) {
                            window.wx && window.wx.miniProgram && window.wx.miniProgram.navigateTo({ url });
                        } else if (/swan\//i.test(UA)) {
                            window.swan && window.swan.webView && window.swan.webView.navigateTo({ url });
                        } else if (/toutiaomicroapp\//i.test(UA)) {
                            window.tt && window.tt.miniProgram && window.tt.miniProgram.navigateTo({ url });
                        }
                    } else {
                        this.openBargainPopup();
                    }
                }).catch(err => {
                    if (err) {
                        this.$easyToast(err);
                    }
                })
            },
            createBargainOrder () {
                this.bargainLoading = true;
                return createBargainOrderP({
                    productId: this.productId,
                    activityId: this.baseData && this.baseData.activityId
                }).then(res => {
                    this.bargainLoading = false;
                    if (res && res.data && res.data.bargainId) {
                        this._bargainId = res.data.bargainId;
                        this.$store.dispatch('detail/createBargainOrder', res.data).then(data => {
                            this.$nextTick(() => Promise.resolve());
                        });
                    } else if (res && res.data && res.data.needLogin) {
                        setTimeout(function() {
                            location.href = LOGIN_URL;
                        }, 10);
                        return Promise.reject();
                    } else {
                        return Promise.reject(CREATE_BARGAIN_ERROR_MESSAGE);
                    }
                }).catch(err =>{
                    this.bargainLoading = false;
                    return Promise.reject(err);
                });
            },
            callBargainJSBridge () {
                let ctx = this;
                if (window.G && window.G.webviewBridgeReady && this.baseData) {
                    window.G.webviewBridgeReady(function(bridge) {
                        bridge.callHandler('getAppVersion', {}, function (json) {
                            if (json && json.data && json.data.version && versionCmp(json.data.version, '9.48.0') >= 0) {
                                bridge.callHandler('shareBargain', {
                                    bargainInfo: {
                                        bargainId: ctx.baseData.bargainId,
                                        bargainStatus: ctx.baseData.showStatus,
                                        bargainActivityId:  ctx.baseData.activityId,
                                        bargainAmountMax: ctx.baseData.bargainMax, 
                                        bargainContent: undefined,
                                        bargainImage: undefined,
                                        bargainSlogan: undefined,
                                        peopleCount: ctx.baseData.peopleCount,
                                        priceCount: ctx.baseData.priceCount
                                    },
                                    shareInfo: {
                                        productId: ctx.productId,
                                        bargainMax: ctx.baseData.bargainMax,
                                        destinationName: ctx.destinationName,
                                        headPic: ctx.headPic,
                                        lowestPromoPrice: String(ctx.lowestPrice),
                                        lowestPrice: String(ctx.lowestPrice),
                                        name: ctx.productName,
                                        productType: ctx.classBrandParentName,
                                        remarkSatisfaction: ctx.remarkSatisfaction,
                                        travelCount: ctx.travelCount,
                                        shareContent: `我在发起砍价，最高可砍${ctx.baseData.bargainMax}元；够朋友，就来帮我砍~`
                                    }
                                }, function (json) {});
                            } else {
                                ctx.$easyToast('尊敬的客户您好，您当前的途牛旅游网APP版本不支持砍价功能，请升级至最新版本，敬请谅解~', {
                                    duration: 5000,
                                    horizontalPosition: 'center',
                                    verticalPosition: 'middle'
                                });
                            }
                        });
                    });
                }
            },
            openBargainPopup () {
                this.bargainLoading = true;
                getQrCodeP({
                    bargainId: this.baseData.bargainId || this._bargainId
                }).then(res => {
                    if(res && res.data && res.data.qrCode) {
                        let qrCode = "data:image/png;base64," + res.data.qrCode;
                        let canvas = document.getElementById('J_bargain-canvas');
                        //支持canvas
                        if(canvas && canvas.getContext) {
                            let ctx = canvas.getContext('2d');
                            ctx.fillStyle = '#f8f8f8';
                            ctx.fillRect(0,0,canvas.width,canvas.height);
                            let initHeight = canvas.width * 0.46;
                            //标题
                            initHeight = this.renderText(
                                ctx, this.productName,
                                {width: canvas.width,height: this.sized(18,initHeight)},
                                {fontColor: '#051b28',fontSize: this.sized(14),needWrap: true}
                            );
                            //价格
                            this.renderText(
                                ctx,'￥',
                                { width: this.sized(9),height: initHeight},
                                {fontColor: '#f77333',fontSize: this.sized(12)}
                            );
                            this.renderText(
                                ctx, this.lowestPrice,
                                {width:  this.sized(20), height: initHeight},
                                {fontColor: '#f77333', fontSize: this.sized(20)}
                            );
                            let priceWidth = ctx.measureText(this.lowestPrice).width;
                            this.renderText(
                                ctx, '起',
                                {width: this.sized(22,priceWidth), height: initHeight},
                                {fontColor: '#f77333', fontSize: this.sized(12)}
                            );
                            if(this.travelCount && this.remarkSatisfaction) {
                                    //出游人数及满意度
                                    let countWidth = ctx.measureText(this.travelCount).width;
                                this.renderText(
                                    ctx, this.travelCount,
                                    {width: canvas.width*0.55-countWidth, height:initHeight},
                                    {fontColor: '#a5a5a5', fontSize: this.sized(12)}
                                );
                                this.renderText(
                                        ctx,'人出游',
                                    {width: canvas.width*0.55, height: initHeight},
                                    {fontColor: '#a5a5a5', fontSize: this.sized(12)}
                                );
                                this.renderText(
                                    ctx,this.remarkSatisfaction + '%满意',
                                    {width: canvas.width * 0.75, height: initHeight},
                                    {fontColor: '#a5a5a5', fontSize: this.sized(12)}
                                );
                            } else {
                                //缺失出游人数或者满意度 提示新品上线
                                this.renderText(
                                    ctx,'新品上线',
                                    {width: canvas.width * 0.75, height: initHeight},
                                    {fontColor: '#a5a5a5', fontSize: this.sized(12)}
                                );
                            }
                            //砍价标语
                            initHeight = this.renderText(ctx,
                                this.slogan,
                                { width: canvas.width, height: this.sized(35, initHeight)},
                                { 
                                    rectMatrix: {w0:0, h0: this.sized(12, initHeight), w1: canvas.width, h1: canvas.height},
                                    bgColor: '#ffffff', fontSize: this.sized(12), needWrap: true,fontColor: '#051b28',
                                }
                            );
                            //绘制小程序码
                            let qrImage = new Image();
                            let qrCodeY = canvas.width * 0.3;
                            let ratio = this.ratio;
                            Promise.all(
                                [this.loadImage(ctx, this.headPic, {w0:0,h0:0,w1:canvas.width,h1:canvas.width * 0.46})
                                .then(() => {
                                    this.renderAfterImageLoaded(ctx);
                                }),
                                this.loadImage(ctx, qrCode, {w0:canvas.width * 0.348, h0:initHeight - this.sized(10), w1:this.sized(80), h1:this.sized(80)})
                                ]).then(() =>  {
                                //生成图片
                                    this.toDataUrl(canvas);
                                    this.bargainLoading = false;
                                    this.isShowBargain = true;
                            })
                            //扫码
                            this.renderText(ctx,'微信扫码砍价',
                                {width: canvas.width * 0.37,height: this.sized(100, initHeight-10)},
                                {fontColor: '#051b28', fontSize: this.sized(12)}
                            );
                        } else {
                            //不支持canvas
                            this.bargainLoading = false;
                            this.$easyToast(CREATE_QR_CODE_ERROR_MESSAGE);
                        }
                    } else {
                        //获取小程序码失败
                        this.bargainLoading = false;
                        this.$easyToast(CREATE_QR_CODE_ERROR_MESSAGE);
                    }
                }).catch(err => {
                    this.$easyToast(CREATE_QR_CODE_ERROR_MESSAGE);
                });
            },
            sized (size, base) {
                return base ? base + size * this.ratio : size * this.ratio;
            },
            renderText(canvas, text, position, config) {
                //文字背景框
                if(config && config.bgColor) {
                    canvas.fillStyle = config.bgColor;
                    canvas.fillRect(config.rectMatrix.w0, config.rectMatrix.h0, config.rectMatrix.w1, config.rectMatrix.h1);
                }
                //文字颜色及字号
                canvas.font = "normal " + (config.fontSize || this.sized(13)) + 'px PingFangSC-Regular';
                canvas.fillStyle = config.fontColor || '#ffffff';
                //换行处理
                if(config.needWrap) {
                     let lineWidth = 0,
                        lastSubStrIndex = 0,
                        lineCount = 0,
                        initHeight = position.height;
                        if(canvas.measureText(text).width + this.sized(18) <= position.width) {
                            canvas.fillText(text, this.sized(9), initHeight);
                            initHeight += this.sized(30);
                        } else {
                            for(let i=0; i<text.length; i++) {
                                lineWidth += canvas.measureText(text[i]).width;
                                if((lineWidth + this.sized(18) > position.width) && lineCount == 0) {
                                    lineCount++;
                                    canvas.fillText(text.substring(lastSubStrIndex, i), this.sized(9), initHeight);
                                    initHeight += this.sized(21);
                                    lineWidth = 0
                                    lastSubStrIndex = i;
                                }
                                if(lineCount > 0) {
                                    if(lineWidth + this.sized(18) > position.width) {
                                        canvas.fillText(text.substring(lastSubStrIndex, i-2)+'...', this.sized(9), initHeight);
                                        initHeight += this.sized(30);
                                        break;
                                    }
                                    if(i==text.length-1) {
                                        canvas.fillText(text.substring(lastSubStrIndex,i+1),this.sized(9),initHeight);
                                        initHeight += this.sized(30);
                                    }
                                }
                            }
                        }
                    return initHeight;
                } else {
                    canvas.fillText(text, position.width, position.height);
                }
            },
            loadImage(canvas, imageUrl, position, returnError) {
                return new Promise((resolve, reject) => {
                    let imageObj = new Image();
                    imageObj.setAttribute("crossOrigin", "Anonymous");
                    imageObj.onload = ()=>{
                        canvas.drawImage(imageObj, position.w0, position.h0, position.w1, position.h1);
                        resolve(imageObj);
                    }
                    imageObj.onerror = () => {
                        if (!returnError) {
                            this.loadImage(canvas, "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==", position, true).then(resolve).catch(resolve);
                        } else {
                            reject();
                        }
                    }
                    imageObj.src = imageUrl;
                    if (imageObj.complete || imageObj.complete === undefined) {
                        imageObj.src = imageUrl;
                    }
                })
            },
            renderAfterImageLoaded(ctx) {
                //目的地
                ctx.font = "normal 12px PingFangSC-Regular";
                    let destWidth = ctx.measureText(this.destinationName).width;
                    this.renderText(ctx,
                    this.destinationName,
                        { width: this.sized(13),height: this.sized(23)},
                        {
                            rectMatrix: {w0:this.sized(9), h0: this.sized(9), w1:this.sized(9+destWidth), h1: this.sized(19)},
                            bgColor: '#444444',
                            fontSize: this.sized(12)
                        }
                    );
                
                
                //品类
                ctx.font = "normal 12px PingFangSC-Regular";
                let categoryWidth = ctx.measureText(this.classBrandParentName).width;
                this.renderText(
                    ctx,
                    this.classBrandParentName,
                    {width: this.sized(22+destWidth), height: this.sized(23)},
                    {
                        rectMatrix: {w0: this.sized(18+destWidth), h0: this.sized(9), w1: this.sized(9+categoryWidth), h1: this.sized(19)},
                        bgColor: '#2dbb55',
                        fontSize: this.sized(12)
                    }
                );
                // //可砍金额
                ctx.fillStyle = "rgba(255, 84, 0, 0.9)";
                ctx.beginPath();
                ctx.arc(this.sized(95.7), this.sized(95), this.sized(15.5), -1.3, 1.3); //画半圆
                ctx.fill();
                ctx.closePath();
                this.renderText(
                    ctx,
                    '最高可砍' + this.baseData.bargainMax +'元',
                    {width: this.sized(5),height: this.sized(100)},
                    {
                        rectMatrix: {w0: 0, h0: this.sized(80), w1: this.sized(100), h1: this.sized(30)},
                        bgColor: 'rgba(255, 84, 0, 0.9)',
                    }
                );
            },
            toDataUrl(canvas) {
                let dataUrl = canvas.toDataURL("image/png");
                let img = document.querySelector('#J_image');
                img.crossOrigin = "anonymous";
                img.src = dataUrl;
            },
        }
    }
</script>

<style lang="scss">
@import '../style/common.scss';
.bargain {
    display: flex;
    background: #fff;
    padding: 12px 18px 12px 0;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 18px;
    height: 41px;
    // background: url('https://m3.tuniucdn.com/fb2/t1/G5/M00/53/9E/Cii-s1sx5pqICfVOAAAnIZyUCvYAAJJSQLZ2jIAACc5054.png') 0 0 repeat-x;
    // background-size: auto 42px;
    em {
        font-size: 13px;
        color: #ff5500;
        // margin: 0 2px;
        font-style: normal;
        i {
            font-size: 14px;
            font-style: normal;
        }
    }
    img {
        // float: left;
        width: 44px;
        // margin: -3px 2px 0 18px;
        // position: relative;
        // top: 4px;
    }
    &-slogan {
        font-size: 13px;
        color: #666666;
        line-height: 17px;
        height: 17px;
        margin-left: -60px;
    }
    div {

        // flex: 1;
        // position: relative;
        // border-radius: 100px;
        margin-right: 10px;
        line-height: 41px;
        // float: right;
        color: #A5A5A5;
        font-size: 13px;
        // padding: 7px 18px 7px 10px;
        // right: -5px;
        cursor:pointer;
        // background-image:linear-gradient(143deg, #ff9530 0%, #ff281d 100%);
        // box-shadow:0 2px 4px 0 rgba(255,119,51,0.43);
        height: 41px;
        width: 52px;
        // margin-top: -4px;
        &.bargaining {
            background: #ccc;
            box-shadow: none; 
        }
        .vui-icon {
            font-size:9px;
            margin: 0 -2px;
        }
        img {
            width: 24px;
            height: 24px;
            position: relative;
            left: 50px;
            top: -34px;
        }
    }
    .arrow {
        // position: absolute;
        // right: 7px;
        // top: 43.9%;
        margin-left: 10px; 
        width: 24px;
        height: 24px;
        -webkit-transform: translate(0, -50%) scale(0.7);
        -ms-transform: translate(0, -50%) scale(0.7);
        transform: translate(0, -50%) scale(0.7);
        &:before,
        &:after {
            content: " ";
            // position: absolute;
            // left: 50%;
            // top: 50%;
            width: 50%;
            height: 2px;
            margin: -1px 0 0 -25%;
            background: #c2c6cc;
        }
        &:before {
            transform: translate(0, -4px) rotate(45deg);
        }
        &:after {
            transform: translate(0, 4px) rotate(-45deg);
        }
    }
    .launch-bargain {
        color: #f50;
    }	
}
.bargain-pop {
    width: 75%;
    padding: 12px 25px;
    border-radius: 4px;
    #J_image {
        width: 100%;
        border: 1px solid #e0e0e0;
    }
    .canvas {
        border:1px solid #e0e0e0;

        &-top {
            position: relative;
            &-image {
                img {
                    width: 100%;
                    margin: auto;
                }
            }
            &-category {
                position: absolute;
                top: 9px;
                left: 13px;
                display: inline-block;
                font-size: 12px;
                color: #ffffff;
                text-align: center;
                height:17px;
                line-height: 16px;
                .destination {
                    background: #444444;
                    border-radius: 3px 0 0 3px;
                    float: left;
                    padding: 0 4px;
                }
                .category {
                    background: #2dbb55;
                    border-radius: 0 3px 3px 0;
                    float: left;
                    padding: 0 4px;
                }
            }
            &-amount {
                position: absolute;
                bottom: 9px;
                left: 0;
                opacity: 0.9;
                background: #ff5400;
                width:107px;
                height: 30px;
                border-radius: 0 18px 18px 0;
                color: #ffffff;
                font-size: 13px;
                line-height: 30px;
                text-align: center;
            }
        }
        &-middle {
            background: #f8f8f8;
            padding-bottom: 14px;
            &-title {
                margin-top: 9px;
                margin-left: 9px;
                font-size: 14px;
                color: #051b28;
                line-height: 21px;
                text-align: justity;
            }
            &-price {
                color: #f77333;
                font-size: 12px;
                line-height: 12px;
                margin-top: 9px;
                margin-left: 9px;
                span {
                    margin-left: 4px;
                    margin-right: 4px;
                    font-size: 20px;
                    line-height: 16px;
                }
            }
            &-count {
                color: #a5a5a5;
                font-size: 12px;
                text-align: right;
                margin-top: -16px;
                margin-right: 10px;
            }
        }
        &-bottom {
            background: #ffffff;
            font-size: 14px;
            color: #051b28;
            line-height: 21px;
            .slogan {
                margin: 12px 10px 12px 9px;
            }
            .qr-code {
                text-align: center;
                img {
                    width: 30%;
                    margin: auto;
                }
            }
            .text {
                text-align: center;
                margin-top: 11px;
                font-size: 13px;
                line-height: 13px;
                margin-bottom: 13px;
            }
        }
    }
    &-notice {
        margin-top: 10px;
        font-size: 12px;
        color: #666666;
        line-height: 12px;
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// Bargain.vue